export default{
    cadastra:{
        method:'post',
        url:'ambiente/trabalhor/cadastro'
    },
    delete:{
        method:'delete',
        url:'ambiente/trabalhor/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'ambiente/trabalhor/lista'
    },
    editar:{
        method:'get',
        url:'ambiente/trabalhor/editar{/id}'
    },
    update:{
        method:'post',
        url:'ambiente/trabalhor/update'
    },
    evento:{
        method:'get',
        url:'acidentetrabalhor/evento/2210{/id}'
    },
    eventolista:{
        method:'get',
        url:'acidentetrabalhor/evento/2210/lista{/id}'
    },
    eventocadastra:{
        method:'post',
        url:'ambiente/trabalhor/evento2240/cadastro'
    },
    eventoupdate:{
        method:'post',
        url:'ambiente/trabalhor/evento2240/update'
    },
    eventodelete:{
        method:'delete',
        url:'ambiente/trabalhor/evento2240/deletar{/id}'
    },
}